import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CSForm } from 'src/app/shared/models/cs-form.model';
import { CSFormService } from 'src/app/shared/services/cs-form.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';
import { FormTransactionService } from 'src/app/shared/services/form-transaction.service';
import { FormTransaction } from '../../shared/models/form-transaction.model';
import { generate, Subscription } from 'rxjs';
import { AuthService } from '../account/auth.service';
import { take } from 'rxjs/operators';
import { fileUploadService } from 'src/app/shared/services/fileUpload.service';
import { unescapeLeadingUnderscores } from 'typescript';
import { FormMember } from './form-member.model';
import { User } from '../account/user.model';
import { IdentityService } from 'src/app/shared/services/identity.service';
import { LinkHandlerService } from 'src/app/shared/services/link-handler.service';

declare var $: any;
interface ArrayConstructor {
  isArray(arg: unknown): arg is readonly unknown[];
}

@Component({
    selector: 'app-form-transaction',
    templateUrl: './form-transaction.component.html',
    styleUrls: ['./form-transaction.component.scss'],
    standalone: false
})
export class FormTransactionComponent implements OnInit {
  formRender: any;
  csForm: CSForm;
  formTransaction: FormTransaction;
  pictureUrl: string = '';
  formId: number;
  isLoading: boolean = true;
  confirmation: string = '';
  error: string = '';
  User: User = null;
  user: string;
  userId: string;
  saving: boolean = false;
  submitted: boolean = false;
  members: FormMember[] = [];
  currentMember: FormMember;
  mydata: [{}];
  submittedMember: number = 0;
  formNotFound: boolean = false;
  churchName: string = '';
  buttonName: string = 'Submit';
  memberSelection: boolean = false;
  role: number = 0;
  formExpired: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private formService: CSFormService,
    private formTransactionService: FormTransactionService,
    public globalService: GlobalService,
    private _location: Location,
    private authService: AuthService,
    private fileUploadService: fileUploadService,
    private _identityService: IdentityService,
    private _router: Router,
    private linkHandler: LinkHandlerService
  ) { }

  async ngOnInit() {
    this.User = await this.authService.autoLogin(0);
    if (this.User != null) {
      this.user = this.globalService.currentUser;
      this.userId = this.User.id;
      this.role = this.getRole();
    }
    this.churchName = this.globalService.currentTenant
    this.formId = parseInt(this.route.snapshot.params.formId);
    this.csForm = await this.formService.getForm(this.formId);

    if (this.csForm.formExpires == true)
    {
      let now = new Date();    
      if (new Date(this.csForm.validThru) < now)
      {
        this.formExpired = true;
        this.isLoading = false;
        return;
      }
    }

if (this.csForm?.name) {
  this.globalService.title.push(this.globalService.screenHeader);
  this.globalService.screenHeader = this.csForm.name.trim();
}    

    this.memberSelection = this.csForm.memberSelection;


    if (this.csForm.imageGUIDs != '')
      this.pictureUrl = this.csForm.pictureUrl;
    if (this.csForm.action == 1)
      this.buttonName = 'Join';
    if (this.csForm.paymentsEnabled == true)
      this.buttonName = 'Submit & Pay';
    if (this.csForm.id == 0) {
      this.isLoading = false;
      this.formNotFound = true;
      return;
    }
    if (this.csForm.requireLogin == true && this.csForm.action != 6 && this.user == undefined) {
      this._router.navigate([this.globalService.subdomain + '/login']);
      return;
    }

    if (this.user && this.csForm.action != 6 && this.memberSelection == true)
      this.members = await this.formService.getFormMembers(
        this.userId,
        this.formId
      );
    if (
      this.csForm.requireLogin == true && this.csForm.action != 6 && this.memberSelection == true &&
      (this.members == null || this.members.length == 0)
    ) {
      this._router.navigate([this.globalService.subdomain + '/login']);
      return;
    }
    this.mydata = JSON.parse(this.csForm.formData).filter(a => a['access'] == false || (a['role'] && a['role'].indexOf(this.role.toString()) >= 0));
    if (this.user != undefined)
      this.changingMember(0);

    if (this.user == undefined)
      this.noMember();
    this.isLoading = false;
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //      if (!this.csForm || !this.csForm.name) return;
  //   this.globalService.title.push(this.globalService.screenHeader);
  //   this.globalService.screenHeader = this.csForm.name.trim();
  //   });
  // }       

  getRole() {
    if (this._identityService.hasFormAdmin() == true)
      return 1;
    if (this._identityService.hasFormEditor() == true)
      return 2;
    if (this._identityService.hasFormsView() == true)
      return 3;
  }

  async onFileSelected(event): Promise<string> {
    const file: File = event.target.files[0];

    if (file) {
      let Url = await this.fileUploadService.uploadFile(
        file,
        file.name,
        'attachments'
      );
      return Url;
    }
    return '';
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  isDataComplete(): string {
    let result = '';
    this.formRender.userData
      .filter((a) => a.required == true)
      .forEach((x) => {
        if (!x.userData) result = result + x.label + ', ';
        if (x.userData && x.userData.length >= 1 && this.isEmptyOrSpaces(x.userData[0]))
          result = result + x.label + ', ';
      });
    if (result != '') result = result.substring(0, result.lastIndexOf(', '));
    return result;
  }

  generateCurrentTransaction(): FormTransaction {
    let transaction: FormTransaction = new FormTransaction();
    let hidden = JSON.parse(this.csForm.formData).filter(a => a['access'] == true && (a['role'] && a['role'].indexOf(this.role.toString()) < 0));
    let result = this.fixCheckboxGroup(this.formRender.userData);
    hidden.forEach(b => { result.push(b) })
    transaction.formData = JSON.stringify(result);
    transaction.formId = this.formId;
    transaction.userId = this.userId;
    transaction.createdBy = this.user;
    transaction.creationDate = new Date();
    return transaction;
  }

  fixCheckboxGroup(data: any[]): any[] {
    var result: any[] = [];
    data.forEach(a => {
      if (a['type'] == 'checkbox-group' && a['userData']?.length > 0) {
        a['values']?.filter(b => a['userData']?.some(y => y == b.value)).map(c => c.selected = true);
        result.push(a);
      }
      else {
        result.push(a);
      }
    }
    );
    return result;
  }

  async submit() {
    this.error = '';
    let result = this.isDataComplete();
    if (result != '') {
      this.error = 'Missing Information: ' + result;
      return;
    }
    if (this.csForm.hasCapacity == true) {
      let currentCount = (
        await this.formTransactionService.getAllFormTransactions(this.csForm.id)
      ).length;
      if (currentCount >= this.csForm.capacity) {
        this.error = 'Error: Reached maximum capacity';
        return;
      }
    }
    this.saving = true;
    let files = $('input[type=file]');
    for (let i = 0; i < files.length; i++) {
      let control = files[i].name;
      let foundControl = this.formRender.userData.filter(
        (a) => a.name == control
      )[0];
      foundControl['data'] = [];
      for (let j = 0; j < files[i].files.length; j++) {
        let url = await this.fileUploadService.uploadFile(
          files[i].files[j],
          files[i].files[j].name,
          'attachments'
        );
        foundControl['data'].push({ name: files[i].files[j].name, url: url });
      }
      this.formRender.userData.filter((a) => a.name == control)[0]['data'] =
        foundControl['data'];
    }
    let transaction = this.generateCurrentTransaction();
    if (this.currentMember != null && this.currentMember.id != 0)
      transaction.memberId = this.currentMember.id;
    let response = await this.formTransactionService.addFormTransaction(
      transaction
    );

    if (response?.paymentRequired === true &&
      response?.paymentUrl) {
      this.goHome();
      this.linkHandler.open(response.paymentUrl);
      //window.location.href = response.paymentUrl;

      return;
    }    

    if (response == null) {
      this.error = 'Account found and added!';
      this.clearForm();
    }
    else {

      if (response.id > 0 && this.buttonName.indexOf("Submit") >= 0) {
        this.confirmation =
          'Form Successfully Submitted - Confirmation# TR-' + response.id;
        if (this.csForm.submitUrl != null && this.csForm.submitUrl.trim() != '')
          setTimeout(() => {
            //window.open(this.csForm.submitUrl, 'self');
            this.linkHandler.open(this.csForm.submitUrl);
          })
        // if (this.csForm.singleMode == false)
        //   this.clearForm();
        // else
        this.submitted = true;
      } else if (this.buttonName.indexOf("Submit") >= 0) {
        this.error = 'Failed to Submit Form!';
      }

      if (response.id > 0 && this.buttonName == "Join") {
        this.confirmation =
          'You have successfully joined the group!';
        this.submitted = true;
      } else if (this.buttonName == "Join") {
        this.error = 'Error: Failed to join the group!';
      }
    }

    this.saving = false;
    if (this.currentMember != null)
      this.submittedMember = this.currentMember.id;
  }


  goHome() {
    this._router.navigate(['\home']);
  }  

  assignBasic(fieldname, fieldvalue) {
    let found = this.mydata.find((a) => a['name'] == fieldname);
    if (found) {
      this.mydata.find((a) => a['name'] == fieldname)['userData'] = [{}];
      this.mydata.find((a) => a['name'] == fieldname)['userData'][0] =
        fieldvalue;
    }
  }

  clearForm() {
    this.mydata.forEach(a => {
      a['userData'] = [{}];
      a['userData'][0] = '';
    }
    );
    this.formRender = $('.fb-render').formRender({
      dataType: 'json',
      formData: this.mydata.filter(a => a['access'] == false || (a['role'] && a['role'].indexOf(this.role.toString()) >= 0)),
    });
  }

  noMember() {
    this.formRender = $('.fb-render').formRender({
      dataType: 'json',
      formData: this.mydata.filter(a => a['access'] == false || (a['role'] && a['role'].indexOf(this.role.toString()) >= 0)),
    });
  }

  changingMember(memberIdx) {
    if (this.members) this.currentMember = this.members[memberIdx];
    if (this.submittedMember > 0) {
      var index = this.members.findIndex((a) => a.id == this.submittedMember);
      if (index >= 0) this.members.splice(index, 1);
      this.submitted = false;
      this.confirmation = '';
    }
    if (this.csForm.requireLogin && this.csForm.singleMode) {
      this.members;
    }
    if (this.formRender) {
      this.mydata = JSON.parse(JSON.stringify(this.formRender.filter(a => a['access'] == false || (a['role'] && a['role'].indexOf(this.role.toString()) >= 0))));
    }
    if (this.members) {
      this.assignBasic(
        'bi_first_name',
        this.currentMember ? this.currentMember.firstName : ''
      );
      this.assignBasic(
        'bi_last_name',
        this.currentMember ? this.currentMember.lastName : ''
      );
      this.assignBasic(
        'bi_full_name',
        this.currentMember
          ? this.currentMember.firstName + ' ' + this.currentMember.lastName
          : ''
      );
      this.assignBasic(
        'bi_street',
        this.currentMember ? this.currentMember.street : ''
      );
      this.assignBasic(
        'bi_city',
        this.currentMember ? this.currentMember.city : ''
      );
      this.assignBasic(
        'bi_state',
        this.currentMember ? this.currentMember.state : ''
      );
      this.assignBasic(
        'bi_zip',
        this.currentMember ? this.currentMember.zip : ''
      );
      this.assignBasic(
        'bi_email',
        this.currentMember ? this.currentMember.emailAddress : ''
      );
      this.assignBasic(
        'bi_cell_phone',
        this.currentMember ? this.currentMember.phoneNumber : ''
      );
      this.assignBasic(
        'bi_marital',
        this.currentMember ? this.currentMember.maritalStatus : ''
      );
      this.assignBasic(
        'bi_gender',
        this.currentMember
          ? this.currentMember.gender == false
            ? '0'
            : '1'
          : ''
      );
      this.assignBasic(
        'bi_dob',
        this.currentMember
          ? new Date(this.currentMember.dateOfBirth).toISOString().slice(0, 10)
          : ''
      );
    }
    this.formRender = $('.fb-render').formRender({
      roles: {
        1: 'Viewer'
      },
      dataType: 'json',
      formData: this.mydata.filter(a => a['access'] == false || (a['role'] && a['role'].indexOf(this.role.toString()) >= 0)),
    });
  }
}
